import {objectFromEntries} from '@benchling/js-utils';

import {AnalyticsParameterValue} from 'insights/parameters/__generated/AnalyticsParameterValue';

import {AnalyticsParameterConfigGraphQL as AnalyticsParameterConfig} from '../../../../graphql-fragments/insights/__generated/AnalyticsParameterConfigGraphQL';
import getParameterType from './getParameterType';
import {VALUE_VALIDATORS} from './ValueValidators';

export default function areParameterValuesValid(
  configs: Array<AnalyticsParameterConfig>,
  values: Array<AnalyticsParameterValue>
): boolean {
  const configIdToType = objectFromEntries(configs.map((config) => [config.id, getParameterType(config)]));

  return values.every((value) => VALUE_VALIDATORS[configIdToType[value.config.id]](value.valueJson));
}
